import { gql } from '@apollo/client';

const SubscriptionInfo = gql`
  fragment SubscriptionInfo on Subscription {
    id
    name
    createdAt
    updatedAt
    renewalAt
    state
    subscriptionPrice
    patient {
      id
      firstName
      lastName
    }
    product {
      id
      name
    }
  }
`;

export default SubscriptionInfo;
